import React from "react";
import {useFormikContext} from "formik";
import ErrorMessage from "./ErrorMessage";
import {Form} from "react-bootstrap";
import Select from "react-select";

function AppFormFieldSelect({name, options, width, label, display, feedback = false, ...otherProps}) {
    const {setFieldTouched, setFieldValue, errors, touched, values} = useFormikContext();
    if (display) {
        if (values[display.name] !== display.value) return <></>
    }

    const handleChange = (e) => {
        setFieldValue(name, e.value)
        if (feedback) feedback(e.value)
    }
    return (
        <>
            {label && <Form.Label>{label}</Form.Label>}
            <Select options={options}
                    onBlur={() => setFieldTouched(name)}
                    onChange={e => handleChange(e)}
                    width={width}
                    noOptionsMessage={() => 'Niks gevonden'}
                    {...otherProps}
            />
            <ErrorMessage error={errors[name]} visible={touched[name]}/>
        </>
    );
}

export default AppFormFieldSelect;
